var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "filters-page",
      on: {
        click: function($event) {
          return _vm.closeFilters()
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "filters-page-container",
          on: {
            click: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _c("div", { staticClass: "filter-header" }, [
            _c("p", [_vm._v("Filters")]),
            _vm._v(" "),
            _c("img", {
              staticClass: "x",
              attrs: {
                src:
                  "https://cdn.shopify.com/s/files/1/1363/8433/files/x_f565b23e-dc3f-4bd6-8843-442daa0e1434.svg?v=1719947652",
                alt: "x"
              },
              on: {
                click: function($event) {
                  return _vm.closeFilters()
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "filters-container" },
            [_c("CardsFilter", { attrs: { occasions: _vm.occasionFilters } })],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "button-container" }, [
            _c(
              "button",
              {
                staticClass: "happybox-button white border",
                on: { click: _vm.resetFilters }
              },
              [_vm._v("Reset")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "happybox-button green border",
                on: { click: _vm.applyFilters }
              },
              [_vm._v("Apply")]
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }